import { LabelledSelect } from "../../customFormComponents/LabelledSelect";
import * as React from "react";
import { IGenericsLang, ILabelSelect } from "../../../services/Language/Types";

export interface IClinicSiteTabProps {
    currentSelectedSite: string;
    siteOptions: ILabelSelect[];
    textString: IGenericsLang;
    selectSite(value: string): void;
}

export const ClinicSiteTab = (props: IClinicSiteTabProps) => (
    <div style={{ margin: "0px 28px" }}>
        <SiteSelectionSection {...props} />
    </div>
);

export const SiteSelectionSection = (props: IClinicSiteTabProps) => {
    return (
        <div className="text-center">
            <h2>{props.textString.titles.SelectSiteTitle}</h2>
            <div style={{ width: "100%", textAlign: "center" }}>
                <div style={{ width: "75%", display: "inline-block" }}>
                    <LabelledSelect
                        id="siteSelection"
                        labelText={props.textString.labels.SiteLabel}
                        value={props.currentSelectedSite}
                        options={props.siteOptions}
                        onChange={(value: string) => props.selectSite(value)}
                        required={!props.currentSelectedSite}
                        validationMessage={props.textString.messagesInstructions.SiteRequiredMessage}
                        isInvalid={!props.currentSelectedSite}
                    />
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/ClinicSiteTab.tsx